import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DownloadService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'download'); // La URL base para el servicio de download
  }

    // Descarga el ZIP por loteId
    descargarZipPorLote(loteId: number, nombreZip?: string): Observable<Blob> {
        const params = new HttpParams().set('loteId', loteId);
        const endpoint = 'zip-by-lote';
        return this.downloadBlob(endpoint, params);
    }

    descargarZipLotePorGrupo(loteId: number, usuarioId?: number): Observable<Blob> {
        const params = new HttpParams().set('loteId', loteId).set('usuarioId', usuarioId);
        const endpoint = 'zip-by-lote/grupos';
        return this.downloadBlob(endpoint, params);
    }


}